import { LitElement, html, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import style from './MenuGrid.scss?inline';
import { styleMap } from 'lit/directives/style-map.js';

@customElement('app-menu-grid')
export class MenuGridComponent extends LitElement {
    @property({ type: String }) k_minItemWidth = '50px'; // El tamaño mínimo de cada celda
    @property({ type: Number }) k_maxCols = 3;           // El máximo de columnas permitido
    @property({ type: String }) k_rowGap = '5px';                 // El espacio entre filas

    static styles = [unsafeCSS(style)];

    render() {
        const porcentage = Math.floor(100 / this.k_maxCols);

        const styles = {
            "--col-basis": `max(${this.k_minItemWidth}, ${porcentage}%)`,
            "--row-gap": this.k_rowGap
        }
        return html`
        <nav class="menu-grid" style=${styleMap(styles)}>
            <slot name="menu-item"></slot>
        </nav>
        `;
    }
}